import React from 'react';
import { ToggleButton as RACToggleButton, ToggleButtonProps, composeRenderProps } from 'react-aria-components';
import { tv } from 'tailwind-variants';
import { focusRing } from '~/library/utilities';

let styles = tv({
  extend: focusRing,
  base: 'u-font-bold u-uppercase u-text-[1.4rem] u-italic',
  variants: {
    isSelected: {
      false: 'u-text-blue/60',
      true: 'u-text-blue'
    },
    isDisabled: {
      true: 'u-text-blue/20 u-cursor-not-allowed'
    }
  }
});

export function ToggleButton(props: ToggleButtonProps) {
  return (
    <RACToggleButton
      {...props}
      className={composeRenderProps(
        props.className,
        (className, renderProps) => styles({...renderProps, className})
      )} />
  );
}
